import { Pipe } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { PrefixedTranslatePipe } from './prefixed-translate.pipe'

@Pipe({
  name: 'tenantRole',
  pure: false
})
export class TenantRolePipe extends PrefixedTranslatePipe {

  constructor (translatePipe: TranslatePipe) {
    super(translatePipe, 'TENANT_ROLES.')
  }

}
